import React from "react";
import { Box } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";

const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
`;

const PhoneFrame = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "280px",
  height: "560px",
  backgroundColor: "#1D1D1F",
  borderRadius: "40px",
  padding: "12px",
  boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
  animation: `${float} 6s ease-in-out infinite`,
  margin: "0 auto",
  [theme.breakpoints.down("md")]: {
    width: "240px",
    height: "480px",
    borderRadius: "36px",
    padding: "10px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "200px",
    height: "400px",
    borderRadius: "32px",
    padding: "8px",
  },
}));

const PhoneNotch = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "0",
  left: "50%",
  transform: "translateX(-50%)",
  width: "120px",
  height: "28px",
  backgroundColor: "#1D1D1F",
  borderBottomLeftRadius: "16px",
  borderBottomRightRadius: "16px",
  zIndex: 2,
  [theme.breakpoints.down("md")]: {
    width: "100px",
    height: "24px",
    borderBottomLeftRadius: "14px",
    borderBottomRightRadius: "14px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "80px",
    height: "20px",
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
  },
}));

const PhoneScreen = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  backgroundColor: "#FFFFFF",
  borderRadius: "32px",
  overflow: "hidden",
  position: "relative",
  [theme.breakpoints.down("md")]: {
    borderRadius: "28px",
  },
  [theme.breakpoints.down("sm")]: {
    borderRadius: "24px",
  },
}));

const PhoneMockup = ({ children }) => {
  return (
    <PhoneFrame>
      <PhoneNotch />
      <PhoneScreen>{children}</PhoneScreen>
    </PhoneFrame>
  );
};

export default PhoneMockup;